import { type CaseStatus, STATUS_LABELS } from '@/lib/cases'

const STATUS_STYLES: Record<CaseStatus, string> = {
  draft: 'bg-neutral-100 text-neutral-700 border-neutral-200',
  intake: 'bg-secondary-lightest text-secondary border-secondary-lighter',
  review: 'bg-warning/10 text-warning border-warning/30',
  ready: 'bg-accent-sunset/10 text-accent-sunset border-accent-sunset/30',
  transmitted: 'bg-success/10 text-success border-success/30',
  archived: 'bg-neutral-200 text-neutral-500 border-neutral-300',
}

export function StatusBadge({ status, className = '' }: { status: CaseStatus; className?: string }) {
  return (
    <span
      className={`inline-flex items-center gap-1.5 px-2 py-0.5 rounded text-xs font-semibold border ${STATUS_STYLES[status]} ${className}`}
    >
      <span className="w-1.5 h-1.5 rounded-full bg-current" aria-hidden="true" />
      {STATUS_LABELS[status]}
    </span>
  )
}
